export default [
  {
    path: 'kol/login',
    name: 'h5-kol-login',
    component: () => import(/* webpackChunkName: "h5/kol/login" */ '@/views/h5/kol/login.vue'),
    meta: {
      requireLogin: false,
      notShowDialog: true
    }
  },
  {
    path: 'kol/business-overview',
    name: 'h5-kol-business-overview',
    component: () =>
      import(/* webpackChunkName: "h5/kol/business-overview" */ '@/views/h5/kol/business-overview.vue'),
    // This page owns the product-specific access flow instead of invoking the shared PC login redirect.
    meta: {
      requireLogin: false,
      notShowDialog: true
    }
  }
]
